import type { ShiftMealsList } from '@libs/data-access/queries'
import { Text } from '@libs/ui/ds'
import { usePlanningFormTranslation } from '@libs/utils/translations'
import type { FC } from 'react'

import styles from './MealCol.module.css'
import type { ScheduleType } from './MealRow/MealRow'
import MealRowLegacy from './MealRow/MealRowLegacy'

type Props = {
  meals?: ShiftMealsList
  scheduleType: ScheduleType
}

/**
 * @deprecated
 */

export const hasMealsToShowLegacy = (meals, scheduleType) => {
  if (scheduleType === 'clocked') {
    return (
      meals.filter(meal => {
        const meal_taken =
          typeof meal.get === 'function'
            ? meal.get('clocked_meal_taken_status')
            : meal.clocked_meal_taken_status
        return meal_taken !== null
      }).size > 0
    )
  }
  if (scheduleType === 'planned') {
    return (
      meals.filter(meal => {
        const meal_planned =
          typeof meal.get === 'function'
            ? meal.get('planned_meal_type')
            : meal.planned_meal_type
        return meal_planned !== null
      }).size > 0
    )
  }
  return meals.size > 0
}

/**
 * @deprecated
 */
export const MealColLegacy: FC<Props> = ({ meals, scheduleType }) => {
  const { t } = usePlanningFormTranslation()

  if (!meals) {
    return
  }

  return (
    <div className={styles.Row}>
      <Text as='span' size='m' className={styles.Title}>
        {t('shiftRealHoursForm.mealCol.title')}
      </Text>
      <span className={styles.Col}>
        {meals
          .map(meal => {
            if (meal) {
              return (
                <MealRowLegacy
                  meal={meal}
                  key={meal.get('id')}
                  scheduleType={scheduleType}
                />
              )
            }
            return undefined
          })
          .toArray()}
      </span>
    </div>
  )
}
